import { render } from "./HumanPerceptionView.vue?vue&type=template&id=586d5066&scoped=true"
import script from "./HumanPerceptionView.vue?vue&type=script&lang=js"
export * from "./HumanPerceptionView.vue?vue&type=script&lang=js"

import "./HumanPerceptionView.vue?vue&type=style&index=0&id=586d5066&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586d5066"]])

export default __exports__